// Initialize window.productJSON immediately from any available ProductJson script
if (!window.productJSON) {
    const scripts = document.querySelectorAll('script[id^="ProductJson"]');
    if (scripts.length > 0) {
        try {
            window.productJSON = JSON.parse(scripts[0].textContent);
        } catch (e) {
            console.error('Error parsing ProductJson:', e);
        }
    }
}

if (!customElements.get('product-options')) {
    class ProductOptionPicker extends HTMLElement {
        constructor() {
            super();

            this.form = this.parentElement.querySelector('.product-options-form');
            this.section = this.closest('.main-product');
            this.productOptions = this.querySelectorAll('ul');
            this.productOptionsList = this.querySelectorAll('li');
            this.productDropdowns = this.querySelectorAll('.product-option-picker__dropdown');

            this.sectionId = this.section.dataset.sectionId;
            this.productUrl = this.dataset.productUrl;

            // Toggle Option dropdown
            for (let dropdown of this.productDropdowns) {
                dropdown.addEventListener('click', (event) => {
                    this.dropdown(dropdown, event);
                })

                document.addEventListener('click', (event) => {
                    if (event.target !== dropdown && !dropdown.contains(event.target)) {
                        this.closeDropdown(dropdown)
                    }
                })
            }

            document.body.addEventListener('click', (event) => {
                var option = event.target.closest('.product-option-picker__list-item')
                if (option && !option.classList.contains('disabled') && !option.classList.contains('chosen')) {
                    // Option variant picker
                    this.onClick(option);
                }
            })

            for (let productOption of this.productOptionsList) {
                productOption.addEventListener('focus', () => {
                    productOption.addEventListener('keyup', (event) => {
                        if (event.key === 'Enter') {
                            productOption.click();
                        }
                    })
                });
            }
        }

        onClick(option) {
            // Assign chosen option for the dropdown
            this.selectionPicker(option);

            this.productOptions = option.closest('product-options').querySelectorAll('ul');

            var optionProductUrl = option.querySelector('input').dataset.productUrl;
            var variantId = option.querySelector('input').dataset.variantId;

            var chosenOptionValues = '';
            this.productOptions.forEach(list => {
                for (let list_item of list.children) {
                    if (list_item.classList.contains('chosen')) {
                        var chosenOptionId = list_item.querySelector('input').dataset.id
                        var chosenOptionName = list.dataset.optionName
                        chosenOptionValues = chosenOptionValues + chosenOptionId + ',';
                    }
                }
            });

            chosenOptionValues = chosenOptionValues.slice(0, -1);

            var url = optionProductUrl + '?section_id=' + this.sectionId + '&option_values=' + chosenOptionValues + '&variant=' + variantId;

            fetch(url)
                .then((res) => res.text())
                .then((response) => {
                    var parsed_response = new DOMParser().parseFromString(response, 'text/html');
                    var variantId = parsed_response.querySelector('input[name="id"]').value;

                    // UPDATE: Extract and update the metafield from the response
                    // Method 1: Try to find the metafield script tag in the response
                    let metafieldUpdated = false;
                    const metafieldScripts = parsed_response.querySelectorAll('script');
                    for (let script of metafieldScripts) {
                        if (script.textContent.includes('window.variantImagesMetafield')) {
                            try {
                                eval(script.textContent);
                                metafieldUpdated = true;
                            } catch (e) {
                                console.error('Error executing metafield script:', e);
                            }
                            break;
                        }
                    }

                    // Method 2: If metafield script wasn't found, try to extract from the ProductJson script
                    if (!metafieldUpdated) {
                        const productJsonScripts = parsed_response.querySelectorAll('script[id^="ProductJson"]');
                        for (let script of productJsonScripts) {
                            try {
                                const productData = JSON.parse(script.textContent);
                                if (productData.metafields && productData.metafields.custom && productData.metafields.custom.var_images) {
                                    window.variantImagesMetafield = productData.metafields.custom.var_images;
                                    metafieldUpdated = true;
                                }
                            } catch (e) {
                                console.error('Error parsing ProductJson for metafield:', e);
                            }
                        }
                    }

                    // Get variant images from global metafield (set by Liquid template)
                    let variantImagesToSwap = null;

                    if (window.variantImagesMetafield) {
                        try {
                            const varImagesData = typeof window.variantImagesMetafield === 'string'
                                ? JSON.parse(window.variantImagesMetafield)
                                : window.variantImagesMetafield;

                            let variantImages = null;
                            if (typeof varImagesData === 'object' && !Array.isArray(varImagesData)) {
                                const variantIdStr = String(variantId);
                                variantImages = varImagesData[variantIdStr];
                            } else if (Array.isArray(varImagesData)) {
                                variantImages = varImagesData;
                            }

                            if (variantImages && variantImages.length > 0) {
                                variantImagesToSwap = variantImages;
                            }
                        } catch (e) {
                            console.error('Error parsing var_images:', e);
                        }
                    } if (this.productUrl !== optionProductUrl) {
                        // Replace product HTML
                        this.section.innerHTML = parsed_response.querySelector('.main-product').innerHTML;

                        // Update global product JSON
                        const newProductJSON = parsed_response.querySelector('#ProductJson-' + this.sectionId);
                        if (newProductJSON) {
                            try {
                                window.productJSON = JSON.parse(newProductJSON.textContent);
                            } catch (e) { }
                        }

                        // Update stars
                        updateVariantStars();

                        this.productUrl = optionProductUrl;
                        var newUrl = new URL(window.location.origin + optionProductUrl);
                    }
                    else {
                        var product_options = parsed_response.querySelector('product-options');
                        var product_summary__product_form = parsed_response.querySelector('.product-summary__product-form');
                        var pickup_availability = parsed_response.querySelector('pickup-availability');
                        var priceBlock = parsed_response.querySelector('.product-summary__price');
                        var productGallery = parsed_response.querySelector('.product-gallery');

                        // Update ALL .product-summary__text blocks (there may be multiple)
                        const allTextBlocks = this.section.querySelectorAll('.product-summary__text');
                        const responseTextBlocks = parsed_response.querySelectorAll('.product-summary__text');

                        if (allTextBlocks.length === responseTextBlocks.length && allTextBlocks.length > 0) {
                            allTextBlocks.forEach((block, index) => {
                                const responseBlock = responseTextBlocks[index];
                                if (responseBlock) {
                                    block.innerHTML = responseBlock.innerHTML;
                                }
                            });
                        }

                        // Update pickup availability
                        if (this.section.querySelector('pickup-availability') && pickup_availability) {
                            this.section.querySelector('pickup-availability').innerHTML = pickup_availability.innerHTML;
                        }

                        // Update product form
                        if (this.section.querySelector('.product-summary__product-form') && product_summary__product_form) {
                            this.section.querySelector('.product-summary__product-form').innerHTML =
                                product_summary__product_form.innerHTML;
                        }

                        // Update product options
                        if (this.section.querySelector('product-options') && product_options) {
                            this.section.querySelector('product-options').innerHTML =
                                product_options.innerHTML;
                        }

                        // Update price block
                        if (this.section.querySelector('.product-summary__price') && priceBlock) {
                            this.section.querySelector('.product-summary__price').innerHTML =
                                priceBlock.innerHTML;
                        }

                        // Update product gallery images
                        if (this.section.querySelector('.product-gallery') && productGallery) {
                            const galleryContainer = this.section.querySelector('.product-gallery');

                            // Destroy existing Splide instances BEFORE replacing HTML
                            if (window.splideInstances && window.splideInstances.length > 0) {
                                window.splideInstances.forEach(instance => {
                                    try { instance.destroy(); } catch (e) { console.error('Error destroying instance:', e); }
                                });
                                window.splideInstances = [];
                            }

                            // NOW replace the gallery HTML
                            galleryContainer.innerHTML = productGallery.innerHTML;

                            // Hide placeholder images so Splide only measures real images
                            const placeholders = galleryContainer.querySelectorAll('.lazy-loading-image--placeholder');
                            placeholders.forEach(img => {
                                img.style.width = '0';
                                img.style.height = '0';
                                img.style.position = 'absolute';
                                img.style.visibility = 'hidden';
                            });

                            // Show the main images by injecting CSS override
                            const mainImages = galleryContainer.querySelectorAll('.lazy-loading-image--main');

                            // Add CSS rule to override the hidden state
                            let styleTag = document.querySelector('#lazy-loading-override-style');
                            if (!styleTag) {
                                styleTag = document.createElement('style');
                                styleTag.id = 'lazy-loading-override-style';
                                document.head.appendChild(styleTag);
                            }
                            styleTag.textContent = `.lazy-loading-image--main { opacity: 1 !important; visibility: visible !important; }`;

                            // Also set inline styles as backup
                            mainImages.forEach(img => {
                                img.setAttribute('style', 'opacity: 1 !important; visibility: visible !important;');
                            });

                            // Wait briefly then reinitialize Splide with clean gallery
                            setTimeout(() => {
                                this.reinitializeSplide();

                                // Now swap variant-specific images AFTER Splide is reinitialized
                                if (variantImagesToSwap && variantImagesToSwap.length > 0) {
                                    swapVariantImages(variantImagesToSwap);
                                }

                                updateVariantStars();
                                updateConditionDisplay();
                            }, 200);
                        } else {
                            updateVariantStars();
                            updateConditionDisplay();
                        } var newUrl = new URL(window.location.href);
                    }

                    // URL variant param
                    if (newUrl.searchParams.get('variant') !== null) {
                        newUrl.searchParams.set('variant', variantId);
                    } else {
                        newUrl.searchParams.append('variant', variantId);
                    }

                    if (!Shopify.designMode) {
                        history.pushState({}, null, newUrl);
                    }
                })
                .catch((error) => {
                    throw error;
                });
        }

        selectionPicker(option) {
            var currentDropdown = option.parentElement
            var currentDropdownListItems = currentDropdown.querySelectorAll('li');
            var chosenElements = currentDropdown.parentElement.parentElement.querySelectorAll('.product-option-picker-chosen > span, .product-option-picker-label > .product-option-picker-label--chosen');
            var chosenSwatchElement = currentDropdown.parentElement.parentElement.querySelector('.product-option-picker-chosen > .product-option-swatch')
            var chosenOptionSwatch = option.querySelector('.product-option-swatch');

            for (let item of currentDropdownListItems) {
                item.classList.remove('chosen');
            }
            option.classList.add('chosen');

            for (let chosen of chosenElements) {
                chosen.innerText = option.textContent.trim()
            }

            if (chosenOptionSwatch) {
                var optionProductSwatchStyles = getComputedStyle(chosenOptionSwatch)
                var optionSwatchColor = optionProductSwatchStyles.getPropertyValue('--product-swatch-value');
                if (optionSwatchColor.length == 0) {
                    optionSwatchColor = option.dataset.optionValue
                }
                if (chosenSwatchElement) {
                    chosenSwatchElement.innerHTML = chosenOptionSwatch.innerHTML;
                    chosenSwatchElement.style.setProperty('--product-swatch-value', optionSwatchColor);
                }
            }
        }

        dropdown(dropdown, event) {
            if (dropdown.classList.contains('active')) {
                this.closeDropdown(dropdown)
                dropdown.blur();
            }
            else {
                if (!dropdown.matches(':focus-within:not(:focus)')) {
                    this.openDropdown(dropdown)
                }
            }

            dropdown.classList.contains('active') ? this.closeDropdown(dropdown) : this.openDropdown(dropdown);
        }

        openDropdown(dropdown) {
            dropdown.classList.add('active')
        }

        closeDropdown(dropdown) {
            dropdown.classList.remove('active')
        }

        reinitializeSplide() {
            const productGalleryImagesSelector = '.product-gallery-images';
            const productGalleryThumbnailsSelector = '.product-gallery-thumbnails';
            const productGalleryImages = this.section.querySelector(productGalleryImagesSelector);

            if (!productGalleryImages || !productGalleryImages.classList.contains('splide')) {
                return;
            }

            let productGalleryOptions = {};
            if (productGalleryImages.dataset.options) {
                productGalleryOptions = JSON.parse(productGalleryImages.dataset.options);
            }

            productGalleryOptions['classes'] = {
                arrows: 'splide__arrows',
                arrow: 'splide__arrow',
                prev: 'splide__arrow--prev',
                next: 'splide__arrow--next'
            };

            const main = new Splide(productGalleryImages, productGalleryOptions);
            const productGalleryThumbnails = productGalleryImages.closest('.product-gallery').querySelector(productGalleryThumbnailsSelector);

            if (productGalleryThumbnails) {
                let productThumbnailsOptions = {};
                let productGalleryThumbnailsSize = productGalleryThumbnails.querySelectorAll('.splide__slide').length;

                if (productGalleryThumbnails.dataset.options) {
                    productThumbnailsOptions = JSON.parse(productGalleryThumbnails.dataset.options);
                }

                productThumbnailsOptions['classes'] = {
                    arrows: 'splide__arrows',
                    arrow: 'splide__arrow',
                    prev: 'splide__arrow--prev',
                    next: 'splide__arrow--next'
                };

                productThumbnailsOptions['slideFocus'] = false;
                productThumbnailsOptions['pagination'] = false;
                productThumbnailsOptions['direction'] = 'ttb';
                productThumbnailsOptions['height'] = '430px';
                productThumbnailsOptions['perPage'] = 1;
                productThumbnailsOptions['perMove'] = 1;

                productThumbnailsOptions['dragMinThreshold'] = {
                    mouse: 4,
                    touch: 10,
                };
                productThumbnailsOptions['breakpoints'] = {
                    768: {
                        direction: 'ltr',
                        height: 'auto'
                    },
                };

                if (productGalleryThumbnailsSize < 4) {
                    productThumbnailsOptions['height'] = 'auto';
                }

                const thumbnails = new Splide(productGalleryThumbnails, productThumbnailsOptions);
                window.splideInstances = window.splideInstances || [];
                window.splideInstances.push(main);
                window.splideInstances.push(thumbnails);

                thumbnails.mount();
                main.sync(thumbnails);
                main.mount();

                const thumbnailSlides = productGalleryThumbnails.querySelectorAll('.splide__slide');

                // FIX: Manually attach click handlers to make thumbnails clickable after variant change
                thumbnailSlides.forEach((slide, idx) => {
                    slide.style.cursor = 'pointer';
                    slide.removeEventListener('click', slide._clickHandler);
                    slide._clickHandler = function () {
                        main.go(idx);
                    };
                    slide.addEventListener('click', slide._clickHandler);
                });
            } else {
                window.splideInstances = window.splideInstances || [];
                window.splideInstances.push(main);
                main.mount();
            }
        }
    }

    customElements.define('product-options', ProductOptionPicker)
}

function updateVariantStars() {
    const starContainer = document.querySelector(".item-condition-stars");
    if (!starContainer) return;

    const chosenLabel = document.querySelector(".product-option-picker-label--chosen");
    if (!chosenLabel) return;

    const condition = parseInt(chosenLabel.textContent.trim());
    if (isNaN(condition)) return;

    let html = `<strong style="color:#555; margin-right:10px; font-weight: 500">Condition:</strong>`;

    for (let i = 1; i <= 5; i++) {
        const isFull = i <= condition;

        html += isFull
            ? `<svg class="star full" viewBox="0 0 24 24" width="20" height="20">
                   <path d="M12 .587l3.668 7.568L24 9.748l-6 5.848L19.336 24 12 20.202 4.664 24 6 15.596 0 9.748l8.332-1.593L12 .587z"/>
               </svg>`
            : `<svg class="star empty" viewBox="0 0 24 24" width="20" height="20">
                   <path d="M12 2.248l2.833 5.846 6.45.94-4.666 4.55 1.1 6.414L12 17.77l-5.717 3.228 1.1-6.414-4.666-4.55 6.45-.94L12 2.248z" 
                         fill="none" stroke="currentColor" stroke-width="2"/>
               </svg>`;
    }

    starContainer.innerHTML = html;
}

document.body.addEventListener("click", (event) => {
    if (event.target.closest(".product-option-picker__list-item")) {
        setTimeout(updateVariantStars, 20);
    }
});

function updateConditionDisplay() {
    document.querySelectorAll(".product-option-picker-chosen__value").forEach((el) => {
        const parent = el.closest("product-option-picker");
        if (!parent) return;

        const label = parent.querySelector(".product-option-picker-label span");
        if (!label) return;

        // Only run for Condition selector
        if (label.textContent.trim().toLowerCase() === "condition") {
            const selected = parent.querySelector("input[type='radio']:checked");

            if (selected) {
                el.textContent = `Condition: ${selected.value}`;
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    updateConditionDisplay();

    // On page load, swap variant-specific images if a variant is already selected
    if (window.variantImagesMetafield) {
        try {
            const variantSelector = document.querySelector('[name="id"]');
            if (variantSelector && variantSelector.value) {
                const selectedVariantId = variantSelector.value;

                const varImagesData = typeof window.variantImagesMetafield === 'string'
                    ? JSON.parse(window.variantImagesMetafield)
                    : window.variantImagesMetafield;

                if (varImagesData && typeof varImagesData === 'object' && !Array.isArray(varImagesData)) {
                    const variantImages = varImagesData[selectedVariantId];
                    if (variantImages && variantImages.length > 0) {
                        swapVariantImages(variantImages);
                    }
                }
            }
        } catch (e) {
            console.error('Error initializing variant images on page load:', e);
        }
    }

    // On page load, swap variant-specific notes if metafield is available
    swapVariantNotes();
});

document.addEventListener("variant:change", () => {
    updateConditionDisplay();
    swapVariantNotes();
});

// Swap variant-specific notes
function swapVariantNotes() {
    if (!window.variantNotesMetafield) return;

    const variantSelector = document.querySelector('[name="id"]');
    if (!variantSelector || !variantSelector.value) return;

    const selectedVariantId = variantSelector.value;

    try {
        const notesData = typeof window.variantNotesMetafield === 'string'
            ? JSON.parse(window.variantNotesMetafield)
            : window.variantNotesMetafield;

        if (notesData && typeof notesData === 'object' && !Array.isArray(notesData)) {
            const variantNotes = notesData[selectedVariantId];
            const notesContainer = document.getElementById('variant-notes-container');

            if (notesContainer) {
                if (variantNotes) {
                    notesContainer.innerHTML = `<div class="variant-notes-content">${variantNotes}</div>`;
                    notesContainer.classList.add('show');
                } else {
                    notesContainer.innerHTML = '';
                    notesContainer.classList.remove('show');
                }
            }
        }
    } catch (e) {
        console.error('Error swapping variant notes:', e);
    }
}

// Swap variant-specific images in the gallery
function swapVariantImages(imageUrls) {
    if (!imageUrls || imageUrls.length === 0) return;

    const galleryContainer = document.querySelector('.product-gallery');
    if (!galleryContainer) return;

    // Get reference to the main gallery and thumbnail containers
    const mainGalleryWrapper = galleryContainer.querySelector('.splide');
    const thumbnailGalleryWrapper = galleryContainer.querySelector('.product-gallery-thumbnails');

    // Replace and create main gallery images
    const mainSlides = galleryContainer.querySelectorAll('.product-gallery-images__image');

    mainSlides.forEach((slide, index) => {
        if (index < imageUrls.length) {
            const imageUrl = imageUrls[index];

            // Update the img tag
            const img = slide.querySelector('img');
            if (img) {
                img.src = imageUrl;
                img.dataset.src = imageUrl;
                img.srcset = ''; // Clear srcset to force using src
            }

            // Update the lightbox link if it exists
            const link = slide.querySelector('a[data-lightbox]');
            if (link) {
                link.href = imageUrl;
            }

            // Update the data attribute
            slide.setAttribute('data-image-url', imageUrl);
        } else {
            // Remove extra slides that don't have corresponding images
            slide.remove();
        }
    });

    // Create new main gallery slides if there are more images than existing slides
    if (imageUrls.length > mainSlides.length) {
        const existingCount = mainSlides.length;
        const mainGalleryImages = galleryContainer.querySelector('.product-gallery-images__images') ||
            galleryContainer.querySelector('.splide__list');

        for (let i = existingCount; i < imageUrls.length; i++) {
            const imageUrl = imageUrls[i];

            // Create new main slide
            const newSlide = document.createElement('div');
            newSlide.className = 'product-gallery-images__image splide__slide';
            newSlide.setAttribute('data-image-url', imageUrl);

            // Clone the first slide's structure to maintain consistency
            const firstSlide = mainSlides[0];
            if (firstSlide) {
                const innerContent = firstSlide.innerHTML;
                // Replace image URLs in the cloned content
                newSlide.innerHTML = innerContent
                    .replace(/src="[^"]*"/g, `src="${imageUrl}"`)
                    .replace(/data-src="[^"]*"/g, `data-src="${imageUrl}"`)
                    .replace(/href="[^"]*"(?=\s*[^>]*data-lightbox)/g, `href="${imageUrl}"`);
            }

            if (mainGalleryImages) {
                mainGalleryImages.appendChild(newSlide);
            }
        }
    }

    // Replace thumbnail images
    const thumbnailItems = galleryContainer.querySelectorAll('.product-gallery-thumbnails-thumbnail');

    thumbnailItems.forEach((thumbnailItem, index) => {
        if (index < imageUrls.length) {
            const imageUrl = imageUrls[index];
            const img = thumbnailItem.querySelector('img');

            if (img) {
                img.src = imageUrl;
                img.dataset.src = imageUrl;
                img.srcset = ''; // Clear srcset to force using src
            }

            // Update the data attribute on the thumbnail item itself
            thumbnailItem.setAttribute('data-image-url', imageUrl);
        } else {
            // Remove extra thumbnail items
            thumbnailItem.remove();
        }
    });

    // Create new thumbnail slides if there are more images than existing thumbnails
    if (imageUrls.length > thumbnailItems.length) {
        const existingCount = thumbnailItems.length;
        const thumbnailList = galleryContainer.querySelector('.product-gallery-thumbnails .splide__list');

        for (let i = existingCount; i < imageUrls.length; i++) {
            const imageUrl = imageUrls[i];
            const thumbnail_index = i + 1;

            // Create new thumbnail item
            const newThumbnail = document.createElement('li');
            newThumbnail.className = 'product-gallery-thumbnails-thumbnail splide__slide';
            newThumbnail.setAttribute('data-thumbnail-index', thumbnail_index);
            newThumbnail.setAttribute('data-image-url', imageUrl);
            newThumbnail.setAttribute('tabindex', '0');

            const img = document.createElement('img');
            img.src = imageUrl;
            img.alt = 'Product thumbnail';
            img.loading = 'lazy';

            newThumbnail.appendChild(img);

            if (thumbnailList) {
                thumbnailList.appendChild(newThumbnail);
            }
        }
    }

    // Reinitialize Splide carousels to account for new slides
    const mainGallery = galleryContainer.querySelector('.product-gallery-images');
    const thumbnailGallery = galleryContainer.querySelector('.product-gallery-thumbnails');

    if (mainGallery && mainGallery.classList.contains('splide')) {
        // Find and destroy existing Splide instances for these specific galleries
        if (window.splideInstances && Array.isArray(window.splideInstances)) {
            window.splideInstances = window.splideInstances.filter(instance => {
                try {
                    // Only destroy if the instance's root is one of our galleries
                    if (instance.root === mainGallery || instance.root === thumbnailGallery) {
                        instance.destroy();
                        return false;
                    }
                    return true;
                } catch (e) {
                    return false;
                }
            });
        }

        // Create new main gallery instance
        const isMobile = window.innerWidth < 768;
        const main = new Splide(mainGallery, {
            type: 'fade',
            perPage: 1,
            drag: true,
            arrows: true,
            pagination: !isMobile,
            classes: {
                arrows: 'splide__arrows',
                arrow: 'splide__arrow',
                prev: 'splide__arrow--prev',
                next: 'splide__arrow--next'
            }
        });

        if (thumbnailGallery && thumbnailGallery.classList.contains('splide')) {
            // Create new thumbnail carousel
            const thumbnails = new Splide(thumbnailGallery, {
                rewind: false,
                perPage: 4,
                arrows: true,
                pagination: false,
                slideFocus: false,
                direction: 'ttb',
                height: '430px',
                perMove: 1,
                dragMinThreshold: {
                    mouse: 4,
                    touch: 10
                },
                breakpoints: {
                    768: {
                        direction: 'ltr',
                        height: 'auto'
                    }
                },
                classes: {
                    arrows: 'splide__arrows',
                    arrow: 'splide__arrow',
                    prev: 'splide__arrow--prev',
                    next: 'splide__arrow--next'
                }
            });

            window.splideInstances = window.splideInstances || [];
            window.splideInstances.push(main);
            window.splideInstances.push(thumbnails);

            thumbnails.mount();
            main.sync(thumbnails);
            main.mount();

            // Attach click handlers to thumbnails
            const thumbnailSlides = thumbnailGallery.querySelectorAll('.splide__slide');
            thumbnailSlides.forEach((slide, idx) => {
                slide.style.cursor = 'pointer';
                slide.removeEventListener('click', slide._clickHandler);
                slide._clickHandler = function () {
                    main.go(idx);
                };
                slide.addEventListener('click', slide._clickHandler);
            });
        } else {
            window.splideInstances = window.splideInstances || [];
            window.splideInstances.push(main);
            main.mount();
        }
    }
}